import { Languages } from 'lucide-react';
import { Btn } from '@/components/Btn';
import { useI18n } from '@/i18n/I18nProvider';
import { useSession } from '@/session/SessionProvider';

/**
 * Always visible (plan 5.6). The visible text is the OTHER language's own name ("Español" while the
 * page is English), tagged with its lang attribute so screen readers pronounce it properly.
 * The group carries the "Language" label.
 */
export function LanguageToggle() {
  const { lang, t } = useI18n();
  const { changeLanguage } = useSession();
  const other = lang === 'en' ? 'es' : 'en';
  return (
    <div role="group" aria-label={t('lang.label')}>
      <Btn type="button" variant="ghost" size="lg" lang={other} onClick={() => changeLanguage(other)} className="min-h-[44px]">
        <Languages size={18} aria-hidden="true" />
        {t('lang.toggle')}
      </Btn>
    </div>
  );
}
